
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/calculators/sales-tax-calculator/[salestaxcalculator]",
      function () {
        return require("private-next-pages/calculators/sales-tax-calculator/[salestaxcalculator].jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/calculators/sales-tax-calculator/[salestaxcalculator]"])
      });
    }
  